var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header tw-w-full"},[(_vm.isImpersonateVisible)?_c('ctk-impersonate-nav-bar'):_vm._e(),(_vm.hasNavbar)?_c('ctk-nav-bar'):_vm._e(),(_vm.hasNavbar)?_c('ctk-alert-banners'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }